
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';


@Component({
  selector: 'app-bet-slip',
  templateUrl: './bet-slip.component.html',
  styleUrls: ['./bet-slip.component.css']
})
export class BetSlipComponent extends BaseClass<any> implements OnInit {
  @ViewChild('stakeModal', { static: false }) stakeModal!: ModalDirective;
  public betData: any;
  public stacks: any;
  public stArr: any[] = [];
  public isLoading: boolean = false;
  @Input() data!: any;
  @Output() closeBet = new EventEmitter();
  @Output() updateData = new EventEmitter();
  @Output() changeExpo = new EventEmitter();
  public oneClickdata: any;

  constructor(public service: WebserviceService,
    private _message: MessageService,
    private _common: CommonService,
    private _shared: SharedService,
    public sharedService: SharedService) {
    super();

    // const sub1 = this.sharedService.sharedbetSlipData.subscribe((data: any) => {
    //   // console.log("-----data----");

    //   // console.log(data);
    //   this.betData = data;
    //   if (this.betData)
    //     this.betData?.runners.forEach((element: any, i: any) => {
    //       element['pnlNext'] = '';
    //       element['pnl'] = (this.betData.data.exposes) ? this.betData.data.exposes[i].expose : 0;
    //       element['average'] = (this.betData.data.exposes) ? this.betData.data.exposes[i].average : '';
    //     });
    // });

    const sub1 = this.sharedService.sharedLogin.subscribe((res: any) => {
      if (res && res?.isLogin) {
        this.betData = this.data;
      }
    })
    this.subs.push(sub1);


  }

  ngOnInit(): void {

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  openModal() {
    this.stakeModal.show();
    this.stacks = (localStorage.getItem(`${this.env.panel}stakes`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}stakes`) as any) : [];
    this.stArr = Array(8).fill(0);
  }

  oddsInputLogic = [
    { min: 1, max: 2, value: 0.01, decimals: 2 },
    { min: 2, max: 3, value: 0.02, decimals: 2 },
    { min: 3, max: 4, value: 0.05, decimals: 2 },
    { min: 4, max: 6, value: 0.1, decimals: 2 },
    { min: 6, max: 10, value: 0.2, decimals: 2 },
    { min: 10, max: 20, value: 0.5, decimals: 1 },
    { min: 20, max: 30, value: 1, decimals: 0 },
    { min: 30, max: 50, value: 2, decimals: 0 },
    { min: 50, max: 100, value: 5, decimals: 0 },
    { min: 100, max: 1000, value: 10, decimals: 0 },
  ]
  onChangeOdds(key: string) {
    if (this.betData.key != 'fancy') {
      let isChecked = false;
      this.betData.price = Number(this.betData.price);
      this.oddsInputLogic.forEach(element => {
        if (this.betData.price >= element.min && this.betData.price < element.max && !isChecked) {
          if (key == 'up' && this.betData.price < 999.99) {
            this.betData.price += element.value
          } else if (this.betData.price > 1.01) {
            this.betData.price -= element.value
          }
          this.betData.price = this.betData.price.toFixed(element.decimals);
          isChecked = true;
        }
      });
      this.validateField();
    }
  }
  onChangeStake(key: string) {
    this.betData.stake = Number(this.betData.stake);
    if (key == 'up' && this.betData.stakes.length > 0) {
      this.betData.stake += Number(this.betData.stakes[0].amount);
    } else if (key == 'down' && this.betData.stakes.length > 0 && this.betData.stake > 0) {
      this.betData.stake -= Number(this.betData.stakes[0].amount);
    }
    this.validateField();
  }

  onChangeExpo() {
    // console.log(this.betData.stake);

    // if (this.betData?.data?.exposes) {
    this.betData?.runners.forEach((element: any, i: any) => {
      // console.log(this.betData);
      let odds = this.betData.key == 'book_makers' ? Number(this.betData.price) / 100 : Number(this.betData.price) - 1;
      let sId = element.selectionId ? element.selectionId : element.selection_id;
      let pnl = (this.betData?.exposLisDis[this.betData?.market_id]) ? this.betData?.exposLisDis[this.betData?.market_id][sId]?.expose : 0;
      if (this.betData.selection_id == sId) {
        element["pnlNext"] = (this.betData.side.includes("b")) ?
          (Number(pnl) + (Number(odds)) * Number(this.betData.stake)).toFixed(2) :
          (Number(pnl) - (Number(odds)) * Number(this.betData.stake)).toFixed(2);
      } else {
        element["pnlNext"] = (this.betData.side.includes("b")) ?
          (Number(pnl) - Number(this.betData.stake)).toFixed(2) :
          (Number(pnl) + Number(this.betData.stake)).toFixed(2);
      }
    });
    this.changeExpo.emit(this.betData)
    // }
  }

  digitOnly(e: any) {
    this.validateField();
    return e.charCode >= 48 && e.charCode <= 57
  }

  validateField() {
    // console.log(this.betData?.stake);    
    let price = this.betData?.price;
    let amnt = this.betData?.stake;
    if (price != undefined && price != null && price != 0 && amnt != undefined && amnt != null && amnt != 0) { this.betData.disabled = false } else { this.betData.disabled = true }
    this.onChangeExpo();
  }

  onMinMaxAmountChange(e: any) {
    this.betData.stake as number;
    this.betData.stake = Number(e);
    this.validateField();
  }

  onAllInAmountChange() {
    //console.log(this.betData);
    let user = this.getLocalItem('user');
    user.available_balance = (user?.available_balance == null) ? 0 : user?.available_balance;
    this.betData.stake = (this.roundVal(user?.available_balance) >= this.roundVal(this.betData?.max)) ? Number(this.betData?.max) : this.roundVal(user?.available_balance)
    this.validateField();
  }

  onClear() {
    this.betData.stake = 0;
    this.validateField();
  }

  onAmountChange(e: any) {
    this.betData.stake as number;
    if (this.betData.stake != null || this.betData.stake != undefined) {
      this.betData.stake += Number(e.amount);
    } else {
      this.betData.stake = Number(e.amount);
    }
    this.validateField();
  }

  orderPlaced() {
    if (this.isLogin()) {
      this.isLoading = true;
      this.betData.isSubmitted = true;
      let tempReq = {
        "bet_details[market_id]": this.betData.market_id,
        "bet_details[selection_id]": this.betData.selection_id,
        "bet_details[side]": this.betData.side,
        "bet_details[rate]": this.betData.price,
        "bet_details[price]": this.betData.rate,
        "bet_details[fancy_rate]": this.betData.fancy_rate,
        "bet_details[stake]": this.betData.stake,
        "bet_details[event_id]": this.betData.event_id,
        "bet_details[token]": this.betData.token,
      }
      let req = this._common.JSON_to_URLEncoded(tempReq)

      // console.log(req);
      this.betData.isSubmitted = false
      // return;

      this.getServices().Post(`${this.env.baseUrl + this.api.placeBet}`, req).subscribe(
        (res) => {
          // console.log(res);
          this.isLoading = false;
          this.betData.isSubmitted = false;
          if (res?.data?.status && res?.data?.status == 1) {
            this.betData.isClosed = true;
            this._message.succmessage(res?.data?.message);
            this.sharedService.emitbetSlipRes(res.data);

          } else {

            this._message.errmessage(res.data.error);
          }
          this.closeBet.emit("");
          this.betData.token = res?.data?.token;
          this.updateData.emit(res?.data?.token);
          this.betData = this.data = undefined;
        },
        (err) => {
          this.betData.isSubmitted = false;
          this.closeBet.emit("");
        });
    } else {
      this._common.goToLogin();
      // this.betData = {} ;
      // this._shared.emitLoginModal({ 'login': true });
    }
  }

  setBtnVal() {
    let req = this._common.JSON_to_URLEncoded(this.stacks)
    this.service.Post(`${this.env.baseUrl + this.api.stakesUpdate}`, req)
      .subscribe(
        (res) => {
          if (res.status == true) {
            this._message.succmessage("Stack Updated successfully");
            this.stakeModal.hide();
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.stacks))
            this.betData.stakes = this._common.getStakeArray();
          }
          // this.loaderService.hideLoader();
        },
        (err) => {
          // this.loaderService.hideLoader();
          // this._message.errmessage(err);
        }
      );

  }

  onCloseBet(e: any) {
    this.betData.isClosed = true;
    this.closeBet.emit("");
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngOnChanges() {

    this.betData = this.data;

    if (this.betData?.stake && this.betData?.stake != 0) { this.validateField(); }
    // console.log(this.betData);
    if (this.betData && this.betData?.runners)
      this.betData?.runners.forEach((element: any, i: any) => {
        element['pnlNext'] = '';
        element['pnl'] = (this.betData.data.exposes) ? this.betData.data.exposes[i].expose : 0;
        element['average'] = (this.betData.data.exposes) ? this.betData.data.exposes[i].average : '';
      });
    // console.log(this.betData);
    if (this.data && this.betData && this.betData?.runners) {
      this.oneClickdata = localStorage.getItem(`${this.env.panel}ocBet`) ? JSON.parse(localStorage.getItem(`${this.env.panel}ocBet`) as any) : undefined;
      // console.log(this.oneClickdata);

      if (this.oneClickdata && this.oneClickdata?.switch == true) {
        this.betData.stake = this.oneClickdata.amt
        // console.log(this.betData);

        this.orderPlaced();
      }

    }


  }

  ngAfterContentChecked() {
    this.gotoOpenBetSlip();
  }

  public isIn: boolean = false;
  gotoOpenBetSlip() {
    let location = `goto-${this.betData?.market_id}-${this.betData?.selection_id}`
    let el = document.getElementById(location) as HTMLElement;
    if (el && this.isIn == false) {
      this.gotoDiv(location);
      this.isIn = true;
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
